/**
 * Icon registry for editable marketing sections.
 *
 * Maps string icon names (used in DB-stored section props) to MUI icon components.
 * Keys are derived from the exact icons imported by ProblemsSection, BenefitsSection,
 * and FeaturesSection. Extend this map as new icons are added via the admin builder.
 *
 * resolveIcon(name, fallbackName) never throws — unknown names fall back to a safe default.
 */

import {
  // ProblemsSection icons
  EventSeatOutlined,
  PaidOutlined,
  PersonOffOutlined,
  MenuBookOutlined,
  // BenefitsSection icons
  Groups,
  CurrencyRupee,
  QrCode2,
  WhatsApp,
  // FeaturesSection icons
  QrCode2Outlined,
  AccountBalanceWalletOutlined,
  InsightsOutlined,
  SmartphoneOutlined,
  // Safe fallback
  HelpOutline,
} from '@mui/icons-material';

export const iconRegistry = {
  // Problems
  EventSeatOutlined,
  PaidOutlined,
  PersonOffOutlined,
  MenuBookOutlined,
  // Benefits
  Groups,
  CurrencyRupee,
  QrCode2,
  WhatsApp,
  // Features
  QrCode2Outlined,
  AccountBalanceWalletOutlined,
  InsightsOutlined,
  SmartphoneOutlined,
  // Shared / generic extras useful for admin builder
  HelpOutline,
};

/**
 * Returns the MUI icon component for the given name.
 * Falls back to fallbackName, then HelpOutline — never throws.
 *
 * @param {string} name - Registry key to look up
 * @param {string} [fallbackName] - Optional secondary key to try if name misses
 * @returns {React.ComponentType} MUI icon component
 */
export function resolveIcon(name, fallbackName) {
  if (name && iconRegistry[name]) return iconRegistry[name];
  if (fallbackName && iconRegistry[fallbackName]) return iconRegistry[fallbackName];
  return HelpOutline;
}

export default iconRegistry;
